var map = {
	"./ds/1001.png": 52953,
	"./ds/1002.png": 70018,
	"./ds/2001.png": 83940,
	"./ds/2002.png": 20799,
	"./ds/2003.png": 23862,
	"./ds/2004.png": 63945,
	"./ds/2005.png": 69472,
	"./ds/2006.png": 47803,
	"./ds/2007.png": 32978,
	"./ds/2008.png": 3829,
	"./ds/2010.png": 29954,
	"./ds/2011.png": 20459,
	"./ds/3001.png": 97635,
	"./ds/3002.png": 12360,
	"./ds/3003.png": 10225,
	"./ds/3004.png": 69214,
	"./ds/3005.png": 87527,
	"./ds/3006.png": 67468,
	"./ds/3007.png": 36565,
	"./ds/3008.png": 7410,
	"./ds/3009.png": 21627,
	"./ds/3010.png": 32069,
	"./ds/3011.png": 96156,
	"./ds/3013.png": 4238,
	"./ds/3014.png": 19073,
	"./ds/3015.png": 97944,
	"./ds/3016.png": 93555,
	"./ds/3017.png": 61642,
	"./ds/3018.png": 72413,
	"./ds/3019.png": 51284,
	"./ds/3020.png": 50208,
	"./ds/3021.png": 44681,
	"./ds/3023.png": 28539,
	"./ds/3024.png": 64676,
	"./ds/3025.png": 18573,
	"./ds/3026.png": 4598,
	"./ds/3027.png": 1535,
	"./ds/3029.png": 81905,
	"./ds/3030.png": 67211,
	"./ds/3031.png": 3554,
	"./ds/3032.png": 17561,
	"./ds/3033.png": 1808,
	"./ds/3034.png": 97679,
	"./ds/3035.png": 12582,
	"./ds/3036.png": 96349,
	"./ds/3037.png": 75220,
	"./games-img/AcesandEights50Hand_en.png": 81268,
	"./games-img/AllAmericanPoker50Hand_en.png": 63499,
	"./games-img/AmericanBaccarat_en.png": 27322,
	"./games-img/Baccarat3HZC_en.png": 26416,
	"./games-img/BlackJack3HDoubleExposure_en.png": 12630,
	"./games-img/BlackJack3H_en.png": 20786,
	"./games-img/BonusDuecesWild50Hand_en.png": 75669,
	"./games-img/BonusPoker50Hand_en.png": 76305,
	"./games-img/CaribbeanHoldem_en.png": 7425,
	"./games-img/CaribbeanStud_en.png": 33536,
	"./games-img/DoubleBonusPoker50Hand_en.png": 68316,
	"./games-img/DoubleDoubleBonusPoker50Hand_en.png": 27265,
	"./games-img/DuecesWild50Hand_en.png": 6714,
	"./games-img/EURoulette_en.png": 53679,
	"./games-img/JacksorBetter50Hand_en.png": 55834,
	"./games-img/JokerPoker50Hand_en.png": 79377,
	"./games-img/SG12Zodiacs.png": 39417,
	"./games-img/SG5LuckyLions.png": 67645,
	"./games-img/SG5Mariachis.png": 62797,
	"./games-img/SGAllForOne.png": 16675,
	"./games-img/SGArcaneElements.png": 70108,
	"./games-img/SGArcticWonders.png": 469,
	"./games-img/SGAzlandsGold.png": 7446,
	"./games-img/SGBarnstormerBucks.png": 55420,
	"./games-img/SGBikiniIsland.png": 76206,
	"./games-img/SGBirdOfThunder.png": 86125,
	"./games-img/SGBlackbeardsBounty.png": 77512,
	"./games-img/SGBombsAway.png": 75120,
	"./games-img/SGBuggyBonus.png": 19738,
	"./games-img/SGCakeValley.png": 70520,
	"./games-img/SGCarnivalCash.png": 9262,
	"./games-img/SGCashReef.png": 59514,
	"./games-img/SGCashosaurus.png": 344,
	"./games-img/SGColossalGems.png": 63589,
	"./games-img/SGCoyoteCrash.png": 7457,
	"./games-img/SGDiscoFunk.png": 76121,
	"./games-img/SGDoubleODollars.png": 30334,
	"./games-img/SGDrFeelgood.png": 17792,
	"./games-img/SGDragonsRealm.png": 95940,
	"./games-img/SGDragonsThrone.png": 66003,
	"./games-img/SGEgyptianDreams.png": 41398,
	"./games-img/SGEgyptianDreamsDeluxe.png": 74827,
	"./games-img/SGFaCaiShen.png": 95625,
	"./games-img/SGFaCaiShenDeluxe.png": 98948,
	"./games-img/SGFenghuang.png": 39472,
	"./games-img/SGFireRooster.png": 68713,
	"./games-img/SGFlyingHigh.png": 60700,
	"./games-img/SGFortuneDogs.png": 35919,
	"./games-img/SGFourDivineBeasts.png": 6816,
	"./games-img/SGFrontierFortunes.png": 87856,
	"./games-img/SGGalacticCash.png": 67228,
	"./games-img/SGGangsters.png": 68113,
	"./games-img/SGGlamRock.png": 16953,
	"./games-img/SGGoldRush.png": 69941,
	"./games-img/SGGoldenUnicorn.png": 56340,
	"./games-img/SGGrapeEscape.png": 78445,
	"./games-img/SGHappiestChristmasTree.png": 32107,
	"./games-img/SGHappyApe.png": 94659,
	"./games-img/SGHauntedHouse.png": 40636,
	"./games-img/SGHeySushi.png": 51101,
	"./games-img/SGHotHotFruit.png": 41121,
	"./games-img/SGHotHotHalloween.png": 922,
	"./games-img/SGIndianCashCatcher.png": 30373,
	"./games-img/SGJellyfishFlow.png": 97039,
	"./games-img/SGJellyfishFlowUltra.png": 91025,
	"./games-img/SGJugglenaut.png": 42065,
	"./games-img/SGJump.png": 2005,
	"./games-img/SGJungleRumble.png": 61609,
	"./games-img/SGKanesInferno.png": 46890,
	"./games-img/SGKingTutsTomb.png": 95224,
	"./games-img/SGKnockoutFootball.png": 78602,
	"./games-img/SGKnockoutFootballRush.png": 45896,
	"./games-img/SGLittleGreenMoney.png": 16762,
	"./games-img/SGLondonHunter.png": 45289,
	"./games-img/SGLoonyBlox.png": 60731,
	"./games-img/SGLuckyFortuneCat.png": 79652,
	"./games-img/SGLuckyLucky.png": 64205,
	"./games-img/SGMagicOak.png": 1577,
	"./games-img/SGMonsterMashCash.png": 27581,
	"./games-img/SGMountMazuma.png": 91625,
	"./games-img/SGMrBling.png": 58220,
	"./games-img/SGMummyMoney.png": 71070,
	"./games-img/SGMysticFortune.png": 86927,
	"./games-img/SGNaughtySanta.png": 31502,
	"./games-img/SGNuwa.png": 75046,
	"./games-img/SGOceansCall.png": 11716,
	"./games-img/SGPamperMe.png": 94312,
	"./games-img/SGPandaPanda.png": 33373,
	"./games-img/SGPiratesPlunder.png": 60745,
	"./games-img/SGPoolShark.png": 60164,
	"./games-img/SGPresto.png": 80344,
	"./games-img/SGPuckerUpPrince.png": 39607,
	"./games-img/SGPumpkinPatch.png": 38511,
	"./games-img/SGQueenOfQueens1024.png": 60528,
	"./games-img/SGQueenOfQueens243.png": 21056,
	"./games-img/SGRideEmCowboy.png": 44708,
	"./games-img/SGRodeoDrive.png": 11452,
	"./games-img/SGRollingRoger.png": 10269,
	"./games-img/SGRomanEmpire.png": 60946,
	"./games-img/SGRuffledUp.png": 19524,
	"./games-img/SGSOS.png": 77860,
	"./games-img/SGSantasVillage.png": 34103,
	"./games-img/SGScopa.png": 95693,
	"./games-img/SGScruffyScallywags.png": 51893,
	"./games-img/SGShaolinFortunes100.png": 22540,
	"./games-img/SGShaolinFortunes243.png": 58488,
	"./games-img/SGShogunsLand.png": 52595,
	"./games-img/SGSirBlingalot.png": 32555,
	"./games-img/SGSkysTheLimit.png": 10761,
	"./games-img/SGSpaceFortune.png": 85540,
	"./games-img/SGSparta.png": 11412,
	"./games-img/SGSuperStrike.png": 73450,
	"./games-img/SGSuperTwister.png": 99618,
	"./games-img/SGTabernaDeLosMuertos.png": 45130,
	"./games-img/SGTabernaDeLosMuertosUltra.png": 91586,
	"./games-img/SGTechnoTumble.png": 88733,
	"./games-img/SGTheBigDeal.png": 38710,
	"./games-img/SGTheDeadEscape.png": 70527,
	"./games-img/SGTheDragonCastle.png": 13833,
	"./games-img/SGTheKoiGate.png": 22320,
	"./games-img/SGTowerOfPizza.png": 37967,
	"./games-img/SGTreasureDiver.png": 43476,
	"./games-img/SGTreasureTomb.png": 2772,
	"./games-img/SGVikingsPlunder.png": 35552,
	"./games-img/SGWaysOfFortune.png": 23431,
	"./games-img/SGWealthInn.png": 78745,
	"./games-img/SGWeirdScience.png": 27366,
	"./games-img/SGWickedWitch.png": 38239,
	"./games-img/SGWildTrucks.png": 72213,
	"./games-img/SGWizardsWantWar.png": 3477,
	"./games-img/SGZeus.png": 7510,
	"./games-img/SGZeus2.png": 42454,
	"./games-img/SicBo.png": 81925,
	"./games-img/TGBlackjackAmerican.png": 16128,
	"./games-img/TGDragonTiger.png": 46860,
	"./games-img/TGThreeCardPoker.png": 22993,
	"./games-img/TGThreeCardPokerDeluxe.png": 52524,
	"./games-img/TGWar.png": 41360,
	"./games-img/TensorBetter50Hand.png": 84058,
	"./games-img/game6.png": 83383,
	"./games-img/mv.gif": 985,
	"./haba_pic.png": 63114,
	"./jili_icon.png": 86755,
	"./pg_icon.png": 83232,
	"./prag_icon.png": 35959,
	"./pt_icon.png": 79361,
	"./skywind.png": 28464,
	"./slotds.png": 68850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89101;